import { css, Theme } from '@emotion/react'

interface Props {
  from: number
  to: number
  total: number
}

const infoStyle = (t: Theme) => css`
  font-family: 'Noto Sans JP', sans-serif;
  font-size: 14px;
  color: ${t.c.ec.black};
  display: flex;
  align-items: center;
`

export const PaginationInfo = ({ from, to, total }: Props) => {
  return (
    <span css={infoStyle}>
      {from} - {to}件 / {total.toLocaleString()}件
    </span>
  )
}
